import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { FluentProvider, createLightTheme, Theme, BrandVariants } from "@fluentui/react-components";
import { wrapIcon } from "@fluentui/react-icons";
import Store from "./components/store";

const rootElement: HTMLElement = document.getElementById("container");
const root = createRoot(rootElement);
const store = new Store();
initializeIcons();

export const HistoryIcon = wrapIcon(() => {
  return (
    <svg
      width="17px"
      height="17px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>History</title>
      <g id="Icon/Outline/globe-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-0.000000, 0.000056)" fill="#474747" fillRule="nonzero">
          <g id="globe">
            <path
              d="M21.0794013,17.2499192 L18.6824125,17.2499192 C19.0979106,15.8759256 19.3544094,14.3564328 19.4159091,12.7499403 L22.4623948,12.7499403 C22.3453953,14.3804327 21.8578976,15.9074255 21.0794013,17.2499192 L21.0794013,17.2499192 Z M16.5944223,21.4273996 C17.1929195,20.6669032 17.720917,19.7684074 18.149915,18.7499122 L20.0309062,18.7499122 C19.0904106,19.867407 17.9189161,20.7794027 16.5944223,21.4273996 L16.5944223,21.4273996 Z M3.96898141,18.7499122 L5.8499726,18.7499122 C6.28047059,19.7684074 6.80696812,20.6669032 7.40696531,21.4273996 C6.08097152,20.7794027 4.90947701,19.867407 3.96898141,18.7499122 L3.96898141,18.7499122 Z M4.58397853,12.7499403 C4.64547824,14.3564328 4.90197704,15.8759256 5.3174751,17.2499192 L2.92048632,17.2499192 C2.14198997,15.9074255 1.65449225,14.3804327 1.5374928,12.7499403 L4.58397853,12.7499403 Z M2.92048632,6.74996839 L5.3174751,6.74996839 C4.90197704,8.12396195 4.64547824,9.64345484 4.58397853,11.2499473 L1.5374928,11.2499473 C1.65449225,9.61945495 2.14198997,8.0924621 2.92048632,6.74996839 L2.92048632,6.74996839 Z M7.40696531,2.57248795 C6.80696812,3.33298439 6.28047059,4.23148018 5.8499726,5.24997541 L3.96898141,5.24997541 C4.90947701,4.13248065 6.08097152,3.22048492 7.40696531,2.57248795 L7.40696531,2.57248795 Z M20.0309062,5.24997541 L18.149915,5.24997541 C17.720917,4.23148018 17.1929195,3.33298439 16.5944223,2.57248795 C17.9189161,3.22048492 19.0904106,4.13248065 20.0309062,5.24997541 L20.0309062,5.24997541 Z M12.7499403,11.2499473 L12.7499403,6.74996839 L17.1089199,6.74996839 C17.5619178,8.09996207 17.8499164,9.62845491 17.9174161,11.2499473 L12.7499403,11.2499473 Z M12.7499403,22.4023951 L12.7499403,18.7499122 L16.5044227,18.7499122 C15.5624271,20.701403 14.2319333,22.0543967 12.7499403,22.4023951 L12.7499403,22.4023951 Z M11.2499473,18.7499122 L11.2499473,22.4023951 C9.76795425,22.0543967 8.43896048,20.701403 7.4954649,18.7499122 L11.2499473,18.7499122 Z M11.2499473,1.59749252 L11.2499473,5.24997541 L7.4954649,5.24997541 C8.43896048,3.29848455 9.76795425,1.94549089 11.2499473,1.59749252 L11.2499473,1.59749252 Z M12.7499403,1.59749252 C14.2319333,1.94549089 15.5624271,3.29848455 16.5044227,5.24997541 L12.7499403,5.24997541 L12.7499403,1.59749252 Z M6.89096773,6.74996839 L11.2499473,6.74996839 L11.2499473,11.2499473 L6.08247151,11.2499473 C6.15147119,9.62845491 6.43796985,8.09996207 6.89096773,6.74996839 L6.89096773,6.74996839 Z M6.08247151,12.7499403 L11.2499473,12.7499403 L11.2499473,17.2499192 L6.89096773,17.2499192 C6.43796985,15.8999255 6.15147119,14.3714327 6.08247151,12.7499403 L6.08247151,12.7499403 Z M17.1089199,17.2499192 L12.7499403,17.2499192 L12.7499403,12.7499403 L17.9174161,12.7499403 C17.8499164,14.3714327 17.5619178,15.8999255 17.1089199,17.2499192 L17.1089199,17.2499192 Z M19.4159091,11.2499473 C19.3544094,9.64345484 19.0979106,8.12396195 18.6824125,6.74996839 L21.0794013,6.74996839 C21.8578976,8.0924621 22.3453953,9.61945495 22.4623948,11.2499473 L19.4159091,11.2499473 Z M11.9999438,0 C5.37297484,0 -2.62179186e-16,5.37297484 -2.62179186e-16,11.9999438 C-2.62179186e-16,18.6269128 5.37297484,23.9998876 11.9999438,23.9998876 C18.6269128,23.9998876 23.9998876,18.6269128 23.9998876,11.9999438 C23.9998876,5.37297484 18.6269128,0 11.9999438,0 L11.9999438,0 Z"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "historyIcon");

export const ChatIcon = wrapIcon(() => {
  return (
    <svg
      width="17px"
      height="17px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Chat</title>
      <g id="Icon/Outline/comment-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-0.000000, -0.000000)" fill="#474747" fillRule="nonzero">
          <g id="comment">
            <path
              d="M3,24 L3,17.8484742 C1.14421947,15.9546685 0,13.3609576 0,10.5 C0,4.70101014 4.70101014,0 10.5,0 L13.5,0 C19.29899,0 24,4.70101014 24,10.5 C24,16.2989899 19.29899,21 13.5,21 L10.5,21 C9.71103807,21 8.94239974,20.9129842 8.20315863,20.748026 L3,24 Z M4.50000001,21.2936286 L7.92964451,19.1501009 L8.52984206,19.2840321 C9.17097499,19.427098 9.83022732,19.5 10.5,19.5 L13.5,19.5 C18.4705628,19.5 22.5,15.4705628 22.5,10.5 C22.5,5.52943727 18.4705628,1.50000001 13.5,1.50000001 L10.5,1.50000001 C5.52943727,1.50000001 1.50000001,5.52943727 1.50000001,10.5 C1.50000001,12.888735 2.4327426,15.12643 4.07136141,16.7986243 L4.50000001,17.2360457 L4.50000001,21.2936286 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "chatIcon");

export const GPTIcon = wrapIcon(() => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Fill/particulates-fill" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(0.000000, 1.000000)" fill="#D04A02" fillRule="nonzero">
          <path
            d="M5.88001549,11.1032969 C5.88811421,9.91269598 5.17732554,8.83475699 4.07980046,8.37319997 C2.98227539,7.91164295 1.71472844,8.15760579 0.86948328,8.99615025 C0.0242381236,9.83469471 -0.231805255,11.1002439 0.221002008,12.2014077 C0.673809271,13.3025716 1.74605699,14.021917 2.93668468,14.0233023 L2.93668468,14.0233023 C4.55467282,14.0269935 5.87083702,12.7212632 5.88001549,11.1032969 Z M14.936722,11.1032969 C14.943424,9.91403373 14.2322241,8.83811488 13.1354195,8.37831906 C12.0386149,7.91852323 10.7727795,8.16564117 9.92944012,9.00419424 C9.08610079,9.84274731 8.83178239,11.1071558 9.28532833,12.2065595 C9.73887427,13.3059633 10.8107279,14.0233116 12.0000103,14.0233116 C12.7767871,14.0259506 13.5227561,13.7196943 14.0735843,13.1719922 C14.6244126,12.6242901 14.9349095,11.8800763 14.936722,11.1032969 Z M21.0600025,8.1799583 C19.447693,8.18915842 18.1472399,9.50202062 18.1533379,11.1143447 C18.1594789,12.7266688 19.4698603,14.0296217 21.0821931,14.0265804 C22.6945259,14.0235284 24,12.7156326 24,11.1032969 L24,11.1032969 C23.9944858,9.48456441 22.6787402,8.17627773 21.0600025,8.1799583 L21.0600025,8.1799583 Z M7.0400145,16.5132923 C5.42727151,16.5224881 4.12664284,17.8360281 4.13335162,19.4487832 C4.14011247,21.0615384 5.45166618,22.36417 7.06442973,22.3599067 C8.67719328,22.3556224 9.98182473,21.046058 9.98001387,19.4332898 L9.98001387,19.4332898 C9.96901922,17.8173899 8.65595176,16.5132923 7.0400145,16.5132923 Z M16.0966734,16.5132751 C14.4839304,16.5224881 13.1833018,17.8360281 13.1900105,19.4487832 C13.1967714,21.0615384 14.5083251,22.36417 16.1210887,22.3599067 C17.7338522,22.3556224 19.0384837,21.046058 19.0366728,19.4332898 L19.0366728,19.4332898 C19.0340233,18.6562047 18.7227859,17.9119993 18.1714284,17.3643926 C17.620071,16.8167859 16.8737584,16.5106356 16.0966734,16.5132751 L16.0966734,16.5132751 Z M7.0400145,5.84664255 C8.6527575,5.83743892 9.95338616,4.52389896 9.94667738,2.9111438 C9.93991653,1.29838865 8.62836283,-0.00424292113 7.01559928,2.03761209e-05 C5.40283572,0.004304646 4.09820427,1.31386905 4.10001513,2.92663724 L4.10001513,2.92663724 C4.10736483,4.54406633 5.42257293,5.85032745 7.0400145,5.84664255 Z M16.0966734,5.8466367 C17.7094283,5.83927889 19.0115558,4.5272198 19.0066712,2.91445555 C19.0017591,1.30169131 17.6916858,-0.00243394515 16.0789159,3.41092501e-06 C14.4661461,0.00244760799 13.1600093,1.31053222 13.1600093,2.92330391 L13.1600093,2.92330391 C13.1655222,4.54073291 14.4792361,5.84848214 16.0966734,5.8466367 L16.0966734,5.8466367 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
}, "gptIcon");

export const DocumentIcon = wrapIcon(() => {
  return (
    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.335 14.1567H8.33496V15.6733H14.335V14.1567Z" fill="#295477" />
      <path d="M8.33496 9.60667V11.1233H18.6683V9.60667H8.33496Z" fill="#295477" />
      <path d="M8.33496 5.05667V6.57333H18.6683V5.05667H8.33496Z" fill="#295477" />
      <path
        d="M20.855 0H6.14829C5.28496 0 4.58496 0.726667 4.58496 1.62V2.76667H3.14829C2.28496 2.76667 1.58496 3.49333 1.58496 4.39V22.38C1.58496 23.2767 2.28496 24 3.14829 24H17.8516C18.715 24 19.415 23.2733 19.415 22.38V20.9H20.8516C21.715 20.9 22.415 20.1767 22.415 19.2833V1.62C22.4183 0.726667 21.7183 0 20.855 0ZM17.9183 22.38C17.9183 22.4467 17.875 22.48 17.855 22.48H3.14829C3.12496 22.48 3.08496 22.4467 3.08496 22.38V4.38667C3.08496 4.32 3.12829 4.28333 3.14829 4.28333H4.58496V19.2767C4.58496 20.17 5.28496 20.8933 6.14829 20.8933H17.9183V22.38ZM20.9183 19.2833C20.9183 19.35 20.875 19.3833 20.855 19.3833H6.14829C6.12496 19.3833 6.08496 19.35 6.08496 19.2833V1.62C6.08496 1.55333 6.12829 1.52 6.14829 1.52H20.8516C20.875 1.52 20.915 1.55333 20.915 1.62V19.2833H20.9183Z"
        fill="#295477"
      />
    </svg>
  );
}, "documentIcon");

export const RobotIconGPT = wrapIcon(() => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/bot-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(3.000000, 0.000000)" fill="#D04A02" fillRule="nonzero">
          <g id="Outline">
            <path
              d="M9.74,0 L9.74,2.30666667 L13,2.30666667 C13.7219689,2.30843132 14.413617,2.59715473 14.9225621,3.10922603 C15.3852395,3.5747454 15.6624106,4.19012585 15.7069858,4.84058976 L15.7133333,5.03666667 L15.7133333,10.8333333 L10.38,10.8333333 L10.38,12.2233333 L13.0266667,12.2233333 C15.6958559,12.2233333 17.8790845,14.16402 17.9951471,16.5931405 L18,16.7966667 L18,24 L0,24 L0,15.8 C0,14.2373529 2.17297578,12.3387111 4.739023,12.228378 L4.97333333,12.2233333 L7.62,12.2233333 L7.62,10.8333333 L2.28666667,10.8333333 L2.28666667,5.03666667 C2.2840102,4.31470055 2.5684928,3.62129733 3.0774379,3.10922603 C3.54011527,2.64370667 4.15378688,2.36277233 4.80396564,2.31421482 L5,2.30666667 L8.26,2.30666667 L8.26,0 L9.74,0 Z M13.0266667,13.7166667 L4.97333333,13.7166667 C3.02869048,13.7166667 1.58926446,15.0773427 1.48892872,15.7304495 L1.48333333,15.8 L1.48333333,22.5066667 L16.5166667,22.5066667 L16.5166667,16.7966667 C16.5166667,15.0966667 14.9533333,13.7166667 13.0266667,13.7166667 Z M12.2666667,18.3633333 L12.2666667,21.0033333 L9.50666667,21.0033333 L9.50666667,18.3633333 L12.2666667,18.3633333 Z M6.71666667,18.4266667 C7.13824403,18.4266667 7.48,18.7714074 7.48,19.1966667 C7.48,19.6219259 7.13824403,19.9666667 6.71666667,19.9666667 C6.29508931,19.9666667 5.95333333,19.6219259 5.95333333,19.1966667 C5.95333333,18.7714074 6.29508931,18.4266667 6.71666667,18.4266667 Z M12.2666667,15.62 L12.2666667,17.0733333 L9.50666667,17.0733333 L9.50666667,15.62 L12.2666667,15.62 Z M6.71666667,15.53 C7.13824403,15.53 7.48,15.8747407 7.48,16.3 C7.48,16.7252593 7.13824403,17.07 6.71666667,17.07 C6.29508931,17.07 5.95333333,16.7252593 5.95333333,16.3 C5.95333333,15.8747407 6.29508931,15.53 6.71666667,15.53 Z M13,3.96328649 L5,3.96328649 C4.71391094,3.96065806 4.43866617,4.07266644 4.23573645,4.27434351 C4.06179669,4.44720956 3.95340573,4.67361194 3.92655246,4.91493848 L3.91999465,5.03666667 L3.91999465,9.17666667 L14.0666719,9.17666667 L14.0666719,5.03666667 C14.0675521,4.7528846 13.9556686,4.48037393 13.7556295,4.27908458 C13.5555904,4.07779524 13.2837821,3.96421601 13,3.96328649 Z M6.91666667,4.98666667 C7.48367901,4.98666667 7.94333333,5.45079814 7.94333333,6.02333333 C7.94333333,6.59586852 7.48367901,7.06 6.91666667,7.06 C6.34965432,7.06 5.89,6.59586852 5.89,6.02333333 C5.89,5.45079814 6.34965432,4.98666667 6.91666667,4.98666667 Z M11.0833333,4.98666667 C11.6503457,4.98666667 12.11,5.45079814 12.11,6.02333333 C12.11,6.59586852 11.6503457,7.06 11.0833333,7.06 C10.516321,7.06 10.0566667,6.59586852 10.0566667,6.02333333 C10.0566667,5.45079814 10.516321,4.98666667 11.0833333,4.98666667 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "robotIconGPT");

export const RobotIconDocument = wrapIcon(() => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/bot-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(3.000000, 0.000000)" fill="#295477" fillRule="nonzero">
          <g id="Outline">
            <path
              d="M9.74,0 L9.74,2.30666667 L13,2.30666667 C13.7219689,2.30843132 14.413617,2.59715473 14.9225621,3.10922603 C15.3852395,3.5747454 15.6624106,4.19012585 15.7069858,4.84058976 L15.7133333,5.03666667 L15.7133333,10.8333333 L10.38,10.8333333 L10.38,12.2233333 L13.0266667,12.2233333 C15.6958559,12.2233333 17.8790845,14.16402 17.9951471,16.5931405 L18,16.7966667 L18,24 L0,24 L0,15.8 C0,14.2373529 2.17297578,12.3387111 4.739023,12.228378 L4.97333333,12.2233333 L7.62,12.2233333 L7.62,10.8333333 L2.28666667,10.8333333 L2.28666667,5.03666667 C2.2840102,4.31470055 2.5684928,3.62129733 3.0774379,3.10922603 C3.54011527,2.64370667 4.15378688,2.36277233 4.80396564,2.31421482 L5,2.30666667 L8.26,2.30666667 L8.26,0 L9.74,0 Z M13.0266667,13.7166667 L4.97333333,13.7166667 C3.02869048,13.7166667 1.58926446,15.0773427 1.48892872,15.7304495 L1.48333333,15.8 L1.48333333,22.5066667 L16.5166667,22.5066667 L16.5166667,16.7966667 C16.5166667,15.0966667 14.9533333,13.7166667 13.0266667,13.7166667 Z M12.2666667,18.3633333 L12.2666667,21.0033333 L9.50666667,21.0033333 L9.50666667,18.3633333 L12.2666667,18.3633333 Z M6.71666667,18.4266667 C7.13824403,18.4266667 7.48,18.7714074 7.48,19.1966667 C7.48,19.6219259 7.13824403,19.9666667 6.71666667,19.9666667 C6.29508931,19.9666667 5.95333333,19.6219259 5.95333333,19.1966667 C5.95333333,18.7714074 6.29508931,18.4266667 6.71666667,18.4266667 Z M12.2666667,15.62 L12.2666667,17.0733333 L9.50666667,17.0733333 L9.50666667,15.62 L12.2666667,15.62 Z M6.71666667,15.53 C7.13824403,15.53 7.48,15.8747407 7.48,16.3 C7.48,16.7252593 7.13824403,17.07 6.71666667,17.07 C6.29508931,17.07 5.95333333,16.7252593 5.95333333,16.3 C5.95333333,15.8747407 6.29508931,15.53 6.71666667,15.53 Z M13,3.96328649 L5,3.96328649 C4.71391094,3.96065806 4.43866617,4.07266644 4.23573645,4.27434351 C4.06179669,4.44720956 3.95340573,4.67361194 3.92655246,4.91493848 L3.91999465,5.03666667 L3.91999465,9.17666667 L14.0666719,9.17666667 L14.0666719,5.03666667 C14.0675521,4.7528846 13.9556686,4.48037393 13.7556295,4.27908458 C13.5555904,4.07779524 13.2837821,3.96421601 13,3.96328649 Z M6.91666667,4.98666667 C7.48367901,4.98666667 7.94333333,5.45079814 7.94333333,6.02333333 C7.94333333,6.59586852 7.48367901,7.06 6.91666667,7.06 C6.34965432,7.06 5.89,6.59586852 5.89,6.02333333 C5.89,5.45079814 6.34965432,4.98666667 6.91666667,4.98666667 Z M11.0833333,4.98666667 C11.6503457,4.98666667 12.11,5.45079814 12.11,6.02333333 C12.11,6.59586852 11.6503457,7.06 11.0833333,7.06 C10.516321,7.06 10.0566667,6.59586852 10.0566667,6.02333333 C10.0566667,5.45079814 10.516321,4.98666667 11.0833333,4.98666667 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "robotIconDocument");

export const DeleteIcon = wrapIcon(() => {
  return (
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Delete</title>
      <g id="Icon/Outline/delete-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(0.750075, -0.000000)" fill="#E0301E" fillRule="nonzero">
          <g id="delete">
            <path
              d="M17.7263739,20.7839867 L17.9973751,7.55593151 L19.4973813,7.55593151 L19.2263802,20.8149868 C19.1903801,22.5849942 17.744374,24.0000001 15.9743666,24.0000001 L5.13732142,24.0000001 C3.36731404,24.0000001 1.92230802,22.5849942 1.88630787,20.8149868 L1.61430673,7.55593151 L3.11430673,7.55593151 L3.38531412,20.7839867 C3.4053142,21.7299906 4.19131748,22.4999939 5.13732142,22.4999939 L15.9743666,22.4999939 C16.9213705,22.4999939 17.7073738,21.7299906 17.7263739,20.7839867 Z M0.750003131,3.00000001 L20.2499251,3.00000001 C20.6649268,3.00000001 20.9999282,3.33500141 20.9999282,3.75000314 C20.9999282,4.16500487 20.6649268,4.50000001 20.2499251,4.50000001 L0.750003131,4.50000001 C0.335001399,4.50000001 0,4.16500487 0,3.75000314 C0,3.33500141 0.335001399,3.00000001 0.750003131,3.00000001 Z M14.9999219,1.5 L6.00000315,1.5 C5.58500142,1.5 5.25000002,1.16500486 5.25000002,0.750003131 C5.25000002,0.335001397 5.58500142,0 6.00000315,0 L14.9999219,0 C15.4149237,0 15.7499251,0.335001397 15.7499251,0.750003131 C15.7499251,1.16500486 15.4149237,1.5 14.9999219,1.5 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "deleteIcon");

export const CopyIcon = wrapIcon(() => {
  return (
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Copy response</title>
      <g id="Icon/Outline/copy-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icon" transform="translate(2.000000, 0.000000)" fill="#474747" fillRule="nonzero">
          <path
            d="M14.8746292,0 L19.737671,5.40868171 L19.737671,19.2 L14.9376,19.1988 L14.937671,24 L0,24 L0,4.8 L4.8,4.8 L4.8,0 L14.8746292,0 Z M9.11197932,5.9224 L1.203589,5.922 L1.203989,22.8254195 L13.8144,22.8246195 L13.815271,10.9182211 L9.11197932,10.9182211 L9.11197932,5.9224 Z M13.9119793,1.1224 L5.9224,1.1224 L5.922,4.8 L10.0746292,4.8 L14.937671,10.2086817 L14.9376,18.0768 L18.615271,18.0776 L18.615271,6.11822109 L13.9119793,6.11822109 L13.9119793,1.1224 Z M10.2343793,6.39335158 L10.2343793,10.0904252 L13.2634071,10.0904252 L10.2343793,6.39335158 Z M15.0343793,1.59335158 L15.0343793,5.29042515 L18.0634071,5.29042515 L15.0343793,1.59335158 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
}, "copyIcon");

export const ExpandIcon = wrapIcon(() => {
  return (
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Expand response</title>
      <g id="Icon/Outline/expand-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-0.000000, -0.000000)" fill="#474747" fillRule="nonzero">
          <g id="expand">
            <path
              d="M0,0 L7.5,0 L7.5,1.5 L1.5,1.5 L1.5,7.5 L0,7.5 L0,0 Z M16.5000001,0 L24.0000001,0 L24.0000001,7.5 L22.5000001,7.5 L22.5000001,1.5 L16.5000001,1.5 L16.5000001,0 Z M22.5000001,16.5000001 L24.0000001,16.5000001 L24.0000001,24.0000001 L16.5000001,24.0000001 L16.5000001,22.5000001 L22.5000001,22.5000001 L22.5000001,16.5000001 Z M0,16.5000001 L1.5,16.5000001 L1.5,22.5000001 L7.5,22.5000001 L7.5,24.0000001 L0,24.0000001 L0,16.5000001 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "expandIcon");

export const ChevronDownBlackIcon = wrapIcon(() => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/down-chevron-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-0.000000, 5.467500)" fill="#474747" fillRule="nonzero">
          <g id="down-chevron">
            <path
              d="M22.7192768,0.219745424 L11.9995,10.9395221 L1.28072332,0.219745424 C0.987729424,-0.0732484747 0.51273932,-0.0732484747 0.219745423,0.219745424 C-0.0732484743,0.512739323 -0.0732484743,0.987729422 0.219745423,1.28072332 L11.9995,13.060478 L23.7802547,1.28072332 C24.0732486,0.987729422 24.0732486,0.512739323 23.7802547,0.219745424 C23.4872608,-0.0732484747 23.0122706,-0.0732484747 22.7192768,0.219745424"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "chevronDownIcon");

export const ChevronDownWhiteIcon = wrapIcon(() => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/down-chevron-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-0.000000, 5.467500)" fill="#FFFFFF" fillRule="nonzero">
          <g id="down-chevron">
            <path
              d="M22.7192768,0.219745424 L11.9995,10.9395221 L1.28072332,0.219745424 C0.987729424,-0.0732484747 0.51273932,-0.0732484747 0.219745423,0.219745424 C-0.0732484743,0.512739323 -0.0732484743,0.987729422 0.219745423,1.28072332 L11.9995,13.060478 L23.7802547,1.28072332 C24.0732486,0.987729422 24.0732486,0.512739323 23.7802547,0.219745424 C23.4872608,-0.0732484747 23.0122706,-0.0732484747 22.7192768,0.219745424"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "chevronDownIcon");

export const ChevronLeftIcon = wrapIcon(() => {
  return (
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/left-chevron-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(5.467500, -0.000000)" fill="#474747" fillRule="nonzero">
          <g id="left-chevron">
            <path
              d="M12.8411338,0.21975229 C12.5481308,-0.0732507633 12.0731258,-0.0732507633 11.7801227,0.21975229 L0,11.999875 L11.7801227,23.7809978 C11.9271243,23.9269994 12.1191263,24 12.3111283,24 C12.5031303,24 12.6951323,23.9269994 12.8411338,23.7809978 C13.1341369,23.4879947 13.1341369,23.0129898 12.8411338,22.7199868 L2.12102209,11.999875 L12.8411338,1.28076335 C13.1341369,0.987760294 13.1341369,0.512755343 12.8411338,0.21975229"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "chevronLeftIcon");

export const CloseIcon = wrapIcon(() => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Close</title>
      <g id="Icon/Outline/close-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(0.750925, 0.749075)" fill="#474747" fillRule="nonzero">
          <polygon
            id="close-outline"
            points="11.2703555 10.2291233 21.4772728 0.0222059896 22.4981496 1.04308277 12.2912323 11.25 22.4796446 21.4384123 21.4569173 22.4611396 11.268505 12.2727273 1.02087678 22.5203556 0 21.4994788 10.2476283 11.2518506 0.0185049901 1.02272728 1.04123227 0"
          ></polygon>
        </g>
      </g>
    </svg>
  );
}, "closeIcon");

export const Close12Icon = wrapIcon(() => {
  return (
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Close</title>
      <g id="Icon/Outline/close-outline" stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(0.750925, 0.749075)" fill="white" fillRule="nonzero">
          <polygon
            id="close-outline"
            points="11.2703555 10.2291233 21.4772728 0.0222059896 22.4981496 1.04308277 12.2912323 11.25 22.4796446 21.4384123 21.4569173 22.4611396 11.268505 12.2727273 1.02087678 22.5203556 0 21.4994788 10.2476283 11.2518506 0.0185049901 1.02272728 1.04123227 0"
          ></polygon>
        </g>
      </g>
    </svg>
  );
}, "closeIcon");

export const SendIcon = wrapIcon(() => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15805_64032)">
        <path
          d="M0.22 1.28L10.94 12L0.22 22.72C-0.0733334 23.0133 -0.0733334 23.4867 0.22 23.78C0.513333 24.0733 0.986667 24.0733 1.28 23.78L13.06 12L1.28 0.22C0.986667 -0.0733334 0.513333 -0.0733334 0.22 0.22C-0.0733334 0.513333 -0.0733334 0.986667 0.22 1.28Z"
          fill="white"
        />
        <path
          d="M11.16 1.28L21.88 12L11.16 22.72C10.8667 23.0133 10.8667 23.4867 11.16 23.78C11.4533 24.0733 11.9267 24.0733 12.22 23.78L24 12L12.22 0.22C11.9267 -0.0733333 11.4533 -0.0733333 11.16 0.22C10.8667 0.513333 10.8667 0.986667 11.16 1.28Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_15805_64032">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}, "sendIcon");

export const SendDismissIcon = wrapIcon(() => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15805_64032)">
        <path
          d="M0.22 1.28L10.94 12L0.22 22.72C-0.0733334 23.0133 -0.0733334 23.4867 0.22 23.78C0.513333 24.0733 0.986667 24.0733 1.28 23.78L13.06 12L1.28 0.22C0.986667 -0.0733334 0.513333 -0.0733334 0.22 0.22C-0.0733334 0.513333 -0.0733334 0.986667 0.22 1.28Z"
          fill="#BABABA"
        />
        <path
          d="M11.16 1.28L21.88 12L11.16 22.72C10.8667 23.0133 10.8667 23.4867 11.16 23.78C11.4533 24.0733 11.9267 24.0733 12.22 23.78L24 12L12.22 0.22C11.9267 -0.0733333 11.4533 -0.0733333 11.16 0.22C10.8667 0.513333 10.8667 0.986667 11.16 1.28Z"
          fill="#BABABA"
        />
      </g>
      <defs>
        <clipPath id="clip0_15805_64032">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}, "sendIcon");

export const ThumbUpIcon = wrapIcon(() => {
  return (
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/thumb-up-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-0.000000, -0.000000)" fill="#474747" fillRule="nonzero">
          <g id="thumb-up" transform="translate(0.000000, 0.000000)">
            <path
              d="M-3.32424049e-22,9.00000004 L1.5,9.00000004 L1.5,24 L-3.32424049e-22,24 L-3.32424049e-22,9.00000004 Z M15,9 L22.5,9 C23.3284272,9 24,9.67157292 24,10.5 L24,22.5 C24,23.3284272 23.3284272,24 22.5,24 L6.00000002,24 L6.00000002,9 L10.5,4.5 L10.5,2.25000001 C10.5,1.00735932 11.5073594,0 12.7500001,0 C13.9926407,0 15,1.00735932 15,2.25000001 L15,9 Z M7.50000003,22.5 L22.5,22.5 L22.5,10.5 L13.5,10.5 L13.5,2.25000001 C13.5,1.83578645 13.1642136,1.50000001 12.7500001,1.50000001 C12.3357865,1.50000001 12,1.83578645 12,2.25000001 L12,5.12132036 L7.50000003,9.62132037 L7.50000003,22.5 Z"
              id="icons/ol/thumb-up"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "thumbUpIcon");

export const ThumbDownIcon = wrapIcon(() => {
  return (
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/thumb-down-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-0.000000, -0.000000)" fill="#474747" fillRule="nonzero">
          <g id="thumb-down">
            <path
              d="M0,9.00000004 L1.5,9.00000004 L1.5,24 L0,24 L0,9.00000004 Z M15,9 L22.5,9 C23.3284272,9 24,9.67157292 24,10.5 L24,22.5 C24,23.3284272 23.3284272,24 22.5,24 L6.00000003,24 L6.00000003,9 L10.5,4.5 L10.5,2.25000001 C10.5,1.00735932 11.5073594,0 12.7500001,0 C13.9926407,0 15,1.00735932 15,2.25000001 L15,9 Z M7.50000003,22.5 L22.5,22.5 L22.5,10.5 L13.5,10.5 L13.5,2.25000001 C13.5,1.83578645 13.1642136,1.50000001 12.7500001,1.50000001 C12.3357865,1.50000001 12,1.83578645 12,2.25000001 L12,5.12132036 L7.50000003,9.62132037 L7.50000003,22.5 Z"
              id="icons/ol/thumb-down"
              transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(-180.000000) translate(-12.000000, -12.000000) "
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}, "thumbDownIcon");

export const InfoIcon = wrapIcon(() => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 104 99"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Icon/Outline/info-outline" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="InfoIcon" transform="translate(2.000000, 0.000000)" fill="#474747" fillRule="nonzero">
          <path 
            id="Outline-v2" 
            d="M52,85.5a36,36,0,1,0-36-36A36,36,0,0,0,52,85.5ZM52,18A31.5,31.5,0,1,1,20.5,49.5,31.53,31.53,0,0,1,52,18ZM49.75,67h4.5V45.5h-4.5ZM52,37.62a3.38,3.38,0,1,0-3.37-3.37A3.38,3.38,0,0,0,52,37.62Z"
          ></path>
        </g>
      </g>
    </svg>
  );
}, "InfoIcon");

const standardTheme: BrandVariants = {
  10: "#050201",
  20: "#20140E",
  30: "#361F16",
  40: "#49281C",
  50: "#5C3121",
  60: "#6F3B27",
  70: "#84442C",
  80: "#D04A02", // Main Color
  90: "#AE5838",
  100: "#C4623E",
  110: "#DA6C44",
  120: "#F0774A",
  130: "#FE885B",
  140: "#FEDACC", // Disabled
  150: "#FFB69A",
  160: "#FFCBB7",
};

const docsTheme: BrandVariants = {
  10: "#020304",
  20: "#11181F",
  30: "#192735",
  40: "#1E3347",
  50: "#22405A",
  60: "#274E6E",
  70: "#335B7D",
  80: "#295477", // Main Color
  90: "#577592",
  100: "#68829D",
  110: "#7A90A8",
  120: "#8B9EB3",
  130: "#9CACBF",
  140: "#D4DDE4", // Disabled
  150: "#BFCAD6",
  160: "#D1D8E1",
};

export const gptTheme: Theme = {
  ...createLightTheme(standardTheme),
  fontFamilyBase: "Helvetica Neue, Helvetica, Arial, sans-serif",
};

export const documentTheme: Theme = {
  ...createLightTheme(docsTheme),
  fontFamilyBase: "Helvetica Neue, Helvetica, Arial, sans-serif",
};

Office.onReady(() => {
  root.render(
    <FluentProvider theme={gptTheme} style={{ height: "100%" }}>
      <App store={store} />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root.render(NextApp);
  });
}
